import { apiService } from '@shared/services/apiServices';
import type {
  ListMyAssignedTasksParams,
  MyAssignedTasksResponse,
} from '../types/serviceRequestListType';
import serviceRequestEndpoints from './serviceRequestEndpoints';

const EMPTY_RESPONSE: MyAssignedTasksResponse = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    totalCount: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

export const listMyAssignedTasksApiService = {
  listMyAssignedTasks: async (
    params?: ListMyAssignedTasksParams
  ): Promise<MyAssignedTasksResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.start_date) {
      queryParams.append('start_date', params.start_date);
    }
    if (params?.end_date) {
      queryParams.append('end_date', params.end_date);
    }

    const qs = queryParams.toString();
    const endpoint = `${serviceRequestEndpoints.MY_ASSIGNED_TASKS}${qs ? `?${qs}` : ''}`;
    const response = await apiService.getAPI(endpoint);

    if (response.error) {
      return EMPTY_RESPONSE;
    }

    return response.data as MyAssignedTasksResponse;
  },
};
